import axios from "axios";
import auth from "./Auth";

const APPLICATION_KEY = process.env.REACT_APP_APPLICATION_KEY;
const CORE_API_BASES = [
  process.env.REACT_APP_AUTH_URL,
  process.env.REACT_APP_URL,
].filter(Boolean);

const attachApplicationKey = (config) => {
  if (!APPLICATION_KEY) return config;

  const requestUrl = config.url || "";
  const fullUrl = /^https?:\/\//i.test(requestUrl)
    ? requestUrl
    : `${config.baseURL || ""}${requestUrl}`;

  const targetsCoreApi = CORE_API_BASES.some((base) => fullUrl.startsWith(base));
  if (targetsCoreApi) {
    config.headers = config.headers || {};
    config.headers.ApplicationKey = APPLICATION_KEY;
  }

  return config;
};

const api = axios.create({
  baseURL: process.env.REACT_APP_NOT_SECRET_CODE,
});

export const tokenlessApi = axios.create({
  baseURL: process.env.REACT_APP_NOT_SECRET_CODE,
});

api.interceptors.request.use(async (config) => {
  attachApplicationKey(config);
  const token = auth.getToken();
  if (token) {
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

tokenlessApi.interceptors.request.use(attachApplicationKey);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      auth.logout();
      window.location.href = `${window.location.origin}`;
    }
    return Promise.reject(error);
  }
);


export default api;
